'use strict';

function EventUtil ($rootScope) {

  /**
   * Convenience function used to register an event listener to $rootScope from a given scope
   * and simultaneously attach the 'deregister' function to the scope $destroy event to prevent
   * memory leaks.
   *
   * @param {Object} scope Angular scope
   * @param {String} eventname Event to listen for
   * @param {Function} handler Event handler to fire when the event is fired
   */
  this.on = function (scope, eventname, handler) {
    var unregFunc = $rootScope.$on(eventname, handler);
    scope.$on('$destroy', function () {
      console.info('Scope destroyed... unregister $rootScope listeners');
      unregFunc();
    });
  };

  // this.EventEmitter = EventEmitter2;
}

EventUtil.$inject = ['$rootScope'];
module.exports = EventUtil;


// WEBPACK FOOTER //
// ./src/common/utils/EventUtil.js